import styles from './styles.module.scss';
import Link from 'next/link';
import Image from 'next/image';

const SolutionContent = props => {
    const {copy, cta, image, headline} = props || {};

    const renderBackground = () => {
        const {mediaItemUrl, mediaDetails, altText} = image?.node || {};
        if(!mediaItemUrl) return null;
        return(
            <div className={styles.solutionSelector__background}>
                <Image src={mediaItemUrl} width={mediaDetails?.width} height={mediaDetails?.height} alt={altText || headline} />
            </div>
        );
    }

    const renderCopy = () => {
        if(!copy) return null;
    
        return(
            <div className={styles.solutionSelector__copy} dangerouslySetInnerHTML={{__html: copy || " "}}/>

        );
    }

    const renderLink = () => {
        const {url, title} = cta || {};
        return (
            <Link href={url || `#`} className={`${styles.solutionSelector__cta}  button regular primary-fill`}>
                {title}
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path d="M12.6597 4L11.2497 5.41L16.8297 11H4.65967V13H16.8297L11.2497 18.59L12.6597 20L20.6597 12L12.6597 4Z" fill="#FFF"/>
                </svg>
            </Link>
        );
    }
    return (
        <>
            {renderBackground()}

            <div className={styles.solutionSelector__content}>
                <h2 className={styles.solutionSelector__title}>
                    {headline}
                </h2>
                {renderCopy()}
                {renderLink()}
            </div>            
        </>
    );
}

export default SolutionContent;